( function($) {
	$( '.portal-dropdown-container a' ).on( 'click', function(e) {
		e.preventDefault();

		let btn_default = $( this ).closest( '.portal-data-dropdown-container' ).find( 'button' );

		if( btn_default.hasClass( 'portal_member_region_button' ) ) {
			let hidden_input_region =  $( this ).closest( 
				'.portal-data-dropdown-container' ).find( 'input[name="portal_member_region"]'
			);
			let hidden_input_region_id = $( this ).closest( 
				'.portal-data-dropdown-container' ).find( 'input[name="portal_member_region_id"]' 
			);
			let selection_label = $( this ).text();
			let selection_val = $( this ).data( 'value' ); // For setting region

			btn_default.text( selection_label ).css( 'color', "#000" );
			hidden_input_region.val( selection_label );
			hidden_input_region_id.val( selection_val );
		}

		if( btn_default.hasClass( 'portal_member_role_button' ) ) {
			let hidden_input = 
				$( this ).closest( '.portal-data-dropdown-container' ).find( 'input[type="hidden"]' );
			let selection_label = $( this ).text();

			btn_default.text( selection_label ).css( 'color', "#000" );
			hidden_input.val( selection_label );
		}

		if( btn_default.hasClass( 'portal_member_state_button' ) ) {
			let hidden_input = 
				$( this ).closest( '.portal-data-dropdown-container' ).find( 'input[type="hidden"]' );
			let selection_label = $( this ).text();

			btn_default.text( selection_label ).css( 'color', "#000" );
			hidden_input.val( selection_label );
		}

		UIkit.dropdown( $( this ).closest( '.portal-dropdown-container' ) ).hide( false );
	} );

	

	/**
	 * Display cart dropdown if the cart has been updated
	 * or welcome modal if there's a successful password
	 */
	const queryString = window.location.search;
	const urlParams = new URLSearchParams( queryString );
	const cartValue = urlParams.get( 'cart' );
	const memberValue = urlParams.get( 'member' );
	
	if( cartValue === 'updated' ) {
		UIkit.dropdown( $( '#cartajaxtop .shopping-cart-dropdown-container' )[0] ).show();
	}

	if( memberValue === 'welcome' ) {
		UIkit.modal( '#welcomeModal' ).show();
	}
	


	/**
	 * Function to download invoice pdf
	 */
	$( '.download-pdf' ).on( 'click', function(e) { 
		e.preventDefault();

		var orderId = $( this ).data( "orderId" );        
		
		if( orderId !== "" ) { 
			var pdfurl = "/wp-admin/admin-ajax.php?action=view_invoice_pdf&order_id=" + orderId;
			
			window.open( pdfurl, '_blank' );
		}

		return true;  
	} );


	/**
	 * Inject email when inviting user
	 */
	$( '#inviteUser #userInvite_visible_email' ).on( 'change', function() {
		$( '#userInvite_email' ).val( $( this ).val() );
	} );
} )( jQuery );
